import React from "react";
import "./Men_women_kids.css";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";

const SECRET_KEY = "my_secret_key_123"; // 🔒 keep this in env in production

const Men_women_kids = ({allGender}) => {
  const navigate = useNavigate();

  // Function to encrypt gender object
  const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  };

  const handleGender = (gender) => {
    const token = encryptData(gender);
    navigate(`/all-products?re=${encodeURIComponent(token)}`);
  };

  return (
    <section className="Men_women_kids_sec">
      <div className="container">
        <div className="row ms-0 me-0">
          {/* Men */}
          <div
            className="col-4 p-0"
            onClick={() => handleGender({ id: 1, name:allGender[0]?.name })}
          >
            <div className="catsec">
              <div className="img_div">
                <img
                  className="catimg"
                  src={process.env.REACT_APP_IMAGE_URL + allGender[0]?.image}
                  alt="men"
                />
              </div>
              <div className="overlaybg"></div>
              <p className="cat-name">{allGender[0]?.name}</p>
            </div>
          </div>

          {/* Women */}
          <div
            className="col-4 p-0"
            onClick={() => handleGender({ id: 2, name: allGender[1]?.name })}
          >
            <div className="catsec">
              <div className="img_div">
                <img
                  className="catimg"
                  src={process.env.REACT_APP_IMAGE_URL + allGender[1]?.image}
                  alt="women"
                />
              </div>
              <div className="overlaybg"></div>
              <p className="cat-name">{allGender[1]?.name}</p>
            </div>
          </div>

          {/* Kids */}
          <div
            className="col-4 p-0"
            onClick={() => handleGender({ id: 3, name: allGender[2]?.name })}
          >
            <div className="catsec">
              <div className="img_div">
                <img
                  className="catimg"
                  src={process.env.REACT_APP_IMAGE_URL +allGender[2]?.image}
                  alt="kid"
                />
              </div>
              <div className="overlaybg"></div>
              <p className="cat-name">{allGender[2]?.name}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Men_women_kids;
